export default __webpack_public_path__ + "locales/el-GR/PeopleTranslations.json?hash=a4239d4d48cce6b9cf62c4b55869e4d8";